import  React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icons } from "../assest/icons";
import { logger } from '../utils/logger';
import { toast } from "react-toastify";
import LeftSideLogin from "./leftsidelogin";
import { validatePassword } from '../utils/passwordValidation';
import { fetchWithAppCheck } from '../utils/fetchWithAppCheck';


function ResetPwd() {    
  let navigate = useNavigate(); 
  const [resetToken, setResetToken] = useState('');
  const [email, setEmail] = useState('');
  
  const [ShowLoader, setShowLoader] = useState(false); 
  const [firstStep, setFirstStep] = useState(true);
  const [finalStep, setFinalStep] = useState(false);
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [passwordType, setPasswordType] = useState("password");
  const [NewPwd, setNewPwd] = useState('');
  const [ConfirmPwd, setConfirmPwd] = useState('');

  const [errors, setErrors] = useState({});
  const handleLoginPage = () => { 
    navigate("/");
  }
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setResetToken(params.get('token') || '');
    setEmail(params.get('email') || '');
}, []);
const handleResetFormStart= () => { 
  setNewPwd('');  
  setConfirmPwd(''); 
  setErrors('');
};
const handleClickShowPassword = (event) => { 
  if (passwordType === "password") {
    setPasswordType("text");
    return;
  }
  setPasswordType("password");
}; 
const handleClickShowNewPassword = (event) => { 
  if (newPasswordType === "password") {
    setNewPasswordType("text");
    return;
  }
  setNewPasswordType("password");
};
const handleNewPasswordChange = (event) => {
  const { value } = event.target;
  setNewPwd(value);
  setErrors('');
};

const handleConfirmPasswordChange = (event) => {
  const { value } = event.target;
  setConfirmPwd(value);
  setErrors('');
};
  const handleSubmit = async (event) => {
        event.preventDefault();
    
        // Simple form validation
        let formErrors = {};
         if (!NewPwd.trim()) {
          formErrors.NewPwd =  'Please enter your New password';
          }
          if (!ConfirmPwd.trim()) {
              formErrors.ConfirmPwd = 'Please enter your Confirmed password';
          }
          const pwdCheck = validatePassword(NewPwd);
          if (!pwdCheck.valid) {
            formErrors.NewPwd = pwdCheck.error;
          }
          if (NewPwd !== ConfirmPwd ) {
            formErrors.ConfirmPwd = 'New password and confirm password do not match';
          }
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }
        
        if (!resetToken || !email) {
          toast.error("Invalid or expired reset link.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
        
        setShowLoader(true);

        try {
          const functionsBase = process.env.REACT_APP_FUNCTIONS_BASE_URL
            || 'https://us-central1-aigicare-prod.cloudfunctions.net';

          // HIPAA: Token verification, password history check, and bcrypt hashing
          // all run server-side — no password hash is ever exposed to the browser.
          const res = await fetchWithAppCheck(`${functionsBase}/resetPatientPasswordByToken`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: resetToken, email, newPassword: NewPwd }),
          });
          const data = await res.json();

          if (!res.ok) {
            const safeMessages = [
              'Invalid or expired reset link.',
              'Cannot reuse a recent password. Please choose a different password.',
              'New password must be different from your current password.',
            ];
            const msg = safeMessages.includes(data.message) ? data.message : 'Failed to reset password. Please try again.';
            toast.error(msg, { position: toast.POSITION.TOP_RIGHT });
            setShowLoader(false);
            return;
          }

          toast.success("Password reset successfully!", { position: toast.POSITION.TOP_RIGHT });
          setShowLoader(false);
          setFirstStep(false);
          setFinalStep(true);
          handleResetFormStart();
        } catch (error) {
          logger.error('Error resetting password:', error);
          toast.error('Failed to reset password. Please try again.', {
            position: toast.POSITION.TOP_RIGHT,
          });
          setShowLoader(false);
        }
  };
  return (
    <div>
      <div className='container-fluid p-0 bgImageUrl'>
       
        <div className='container p-0 contentBody loginScreen'>

        <LeftSideLogin />
          <div className="col-lg-5 d-inline-block position-relative">
            <div className="loginBoxDiv">
            <div className={"singUpFirstStep "+(firstStep ? "":"d-none")}>
                <h3 className="titleDespTxt">Enter a New Password</h3> 
                <form onSubmit={handleSubmit} autoComplete="off">
               
                 
                <div className='inputGroupDiv'>
                        <label className='labelTxt'> New Password</label>
                      <div className="inputTxtBox registerInputDiv"> 
                      <img src={Icons[0].lockedImg} className="logoImg" alt="" />          
                        <input type={newPasswordType}  value={NewPwd}    
                        onChange={handleNewPasswordChange} /> 
                        <label className='eyePwdIcon' onClick={handleClickShowNewPassword}>  
                          <img src={newPasswordType === "password" ? ( Icons[0].closeEye  ) : ( Icons[0].opneEye  )} className="logoImg" alt="" />
                        </label> 
                      </div> 
                      {errors.NewPwd && <span  className="errorTxt" >{errors.NewPwd}</span>}
                  </div>
                  <div className='inputGroupDiv'>
                        <label className='labelTxt'>Confirm Password</label>
                      <div className="inputTxtBox registerInputDiv">
                        <img src={Icons[0].lockedImg} className="logoImg" alt="" />
                        <input type={passwordType}  value={ConfirmPwd}    
                        onChange={handleConfirmPasswordChange}/>   
                        <label className='eyePwdIcon' onClick={handleClickShowPassword}>  
                          <img src={passwordType === "password" ? ( Icons[0].closeEye  ) : ( Icons[0].opneEye  )} className="logoImg" alt="" />
                        </label>    
                      </div>
                      {errors.ConfirmPwd && <span  className="errorTxt" >{errors.ConfirmPwd}</span>}
                   </div>
                            
                 
                  {ShowLoader ? (<>
                      <button  className="signInBtn" > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button className="signInBtn " type="submit" >Reset Password</button>
                    </>)}
                  
                  <div className="signupDiv"> 
                   <Link to="/">Back to login</Link>
                  </div>
                </form>
             </div> 

              
              <div className={"singUpFinalStep  "+(finalStep ? "":"d-none")}>
                    <span className="emailVerificationDiv w-100">
                    <img src={Icons[0].checkedIcon} className="logoImg" alt="" />
                    <h3>Reset Password</h3>
                    <p>Your password has been successfully reset.</p>
                    <button className="signInBtn mb-0" onClick={handleLoginPage}  >Login</button>
                     </span>
              </div>
            </div>

           
          </div>
          
        </div>
      
      </div>
    </div>
  );
}

export default ResetPwd;
